import { ActivityNimReadDTO } from '../../../api/dto';
import { setChangedFieldsHighlighted } from '../diff';
import { activityFormSchema } from './activity';

export const activityChangeRequestFormSchemaFromActivity = (
    activitySchema: ReturnType<typeof activityFormSchema>,
    previousValue: ActivityNimReadDTO,
    newValue: ActivityNimReadDTO
): ReturnType<typeof activityFormSchema> => {
    return setChangedFieldsHighlighted(activitySchema, [{ previous: previousValue, new: newValue, path: [] }]);
};
